import { colors } from '@constants/colors';

export const useStyles = () => ({
  root: {
    width: 500,
    height: 400,
    background: colors.grey,
    position: 'absolute',
    zIndex: 10000,
    pointerEvents: 'auto',

    '& .MuiTabs-root': {
      width: '100%',
    },

    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-between',
    },

    '& .MuiTab-root': {
      color: 'white',
      width: '33.33%',
      textTransform: 'capitalize',
    },

    '& .Mui-selected': {
      fontWeight: 'bold',
    },

    '& .MuiTabs-indicator': {
      color: colors.mytaLight,
    },
  },
});
